import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  REGISTER: 'REGISTER',
  RESETPASSWORD: 'RESET_PASSWORD',
  SETPASSWORD: 'SET_PASSWORD',
  CLEARERROR: 'CLEARERROR',
};

export const login = (username, password) => {
  return {
    type: ACTION.LOGIN,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_LOGIN,
      data: {
        username,
        password,
      },
    })
      .then(response => {
        localStorage.setItem('access-token', response['auth_token']);
        const roles = response['role'];
        localStorage.setItem('is_inspector', roles.findIndex(role => role.name.toLowerCase() === Constants.ROLES.INSPECTOR) !== -1 );
        localStorage.setItem('is_auditor', roles.findIndex(role => role.name.toLowerCase() === Constants.ROLES.AUDITOR) !== -1 );
        localStorage.setItem('is_admin', response['is_staff'] === true);
        return response;
      })
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const logout = () => {
  return {
    type: ACTION.LOGOUT,
    payload: Promise.resolve().then(() =>
      localStorage.removeItem('access-token'),
    ),
  };
};

export const register = (username, password1, password2, email, first_name, last_name) => {
  return {
    type: ACTION.REGISTER,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_REGISTER,
      data: {
        username,
        password1,
        password2,
        email,
        first_name,
        last_name,
      },
    })
      .then(response => {
        return response;
      })
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const resetPassword = (email) => {
  return {
    type: ACTION.RESETPASSWORD,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_RESET_PASSWORD,
      data: {
        email,
      },
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const setPassword = (password, token, uid) => {
  return {
    type: ACTION.SETPASSWORD,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_SET_PASSWORD,
      data: {
        password,
        token,
        uid,
      },
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const clearError = () => {
  return {
    type: ACTION.CLEARERROR,
    payload: Promise.resolve(),
  };
};



// WEBPACK FOOTER //
// ./src/redux/authentication/authentication_actions.js